<template>
<v-card outlined flat>
  <v-card-actions>
    <strong class="subtitle-1"><i>Separated Billing Items</i></strong>
    <v-spacer></v-spacer>
    <v-alert v-if="edit_priority" type="info" class="ma-0 mr-2 pa-2" dense>The fields are disabled, click and drag rows up or down to change priority</v-alert>
    <v-spacer v-if="edit_priority"></v-spacer>
    <v-btn @click="edit_priority = false" v-if="edit_priority">Done Editing Priority Order</v-btn>
    <v-btn @click="edit_priority = true" v-else>Edit Priority</v-btn>
  </v-card-actions>
  <v-divider></v-divider>
  <v-card-text>
    <v-skeleton-loader v-if="!loading_error" :loading="loading" type="table-body">
      <v-form ref="form">
        <v-simple-table>
          <VueDraggable :disabled="!edit_priority" v-model="items" draggable=".draggable" tag="tbody" @change="updatePriority">
            <tr v-for="(item, index) in items" :key="`separated_line_items_${index}`" :class="`${item.$softDelete ? 'error lighten-2' : ''} draggable`">
              <td>
                <v-text-field v-model="item.name" label="Package Display Name" :disabled="edit_priority" :rules="[$rules.required]"></v-text-field>
              </td>
              <td>
                <v-text-field v-model="item.quick_books_name" label="Quick Books Name" :disabled="edit_priority"></v-text-field>
              </td>
              <td>
                <v-autocomplete v-model="item.is_customer" label="Customer(s)" :items="customers" item-text="primary_name.name" item-value="id" :disabled="edit_priority" multiple></v-autocomplete>
              </td>
              <td>
                <v-autocomplete v-model="item.sample_category_uuid" label="Sample Category" :items="sampleCertTypes" item-text="name" item-value="uuid" :disabled="edit_priority"></v-autocomplete>
              </td>
              <td>
                <v-autocomplete v-model="item.has_tests" label="Has Required Test(s)" :disabled="edit_priority" :items="sampleTestTypes" item-text="name" item-value="uuid" mutliple></v-autocomplete>
              </td>
              <td>
                <v-autocomplete v-model="item.has_flags" label="Has Flag(s)" :items="sampleFlagTypes" item-text="name" item-value="uuid" :disabled="edit_priority" multiple></v-autocomplete>
              </td>
              <td>
                <v-text-field v-model="item.price" label="Price" :disabled="edit_priority" prefix="$" placeholder="0.00"></v-text-field>
              </td>
              <td>
                <v-btn v-if="!item.$softDelete" color="error" outlined @click="remove(item, index)" small shaped :disabled="edit_priority"><v-icon>remove</v-icon></v-btn>
                <v-tooltip v-else bottom>
                  <template v-slot:activator="{on}">
                    <v-btn v-on="on" outlined @click="item.$softDelete = false" small shaped :disabled="edit_priority"><v-icon>undo</v-icon></v-btn>
                  </template>
                  <span>Undo deletion</span>
                </v-tooltip>
              </td>
            </tr>
          </VueDraggable>
          <tfoot>
            <tr>
              <td colspan="8" class="text-center">
                <v-btn @click="addItem" color="success" > <v-icon>mdi-add</v-icon> Add Item</v-btn>
              </td>
            </tr>
          </tfoot>
        </v-simple-table>
      </v-form>
    </v-skeleton-loader>
    <v-alert v-else type="error" class="error" colored-border dense dark >Failed to load config data for separated billing items. <v-btn @click="load" icon small dark><v-icon>refresh</v-icon></v-btn></v-alert>

  </v-card-text>
</v-card>
</template>

<script>
export default {
  name: "BillingSeparatedLineItems",
  components: {
    VueDraggable: () => import('vuedraggable'),
  },
  props: {
    config_ref: {
      required: true
    },
    customers: {
      required: true,
    }
  },
  data: () => ({
    loading: false,
    loading_error: false,
    edit_priority: false,
    items: [],
  }),
  watch: {
    items: {
      deep: true,
      handler(v){
        this.originalItems = v;
      }
    }
  },
  computed: {
    sampleFlagTypes(){
      return this.$store.$db().model('sampleFlagTypes').all();
    },
    sampleCertTypes(){
      return this.$store.$db().model('sampleCertTypeCategories').all();
    },
    sampleTestTypes(){
      return this.$store.$db().model('sampleTestTypes').all();
    },
    originalItems: {
      get: function(){
          return this.$store.$db().model('billingSeparatedItems').query().orderBy('priority').all();
      },
      set: function(v){
        return this.$store.$db().model('billingSeparatedItems').insertOrUpdate({data: v});
      }
    }
  },
  mounted() {
    this.load();
  },
  methods: {
    async load(){
      try {
        const model = this.$store.$db().model('billingSeparatedItems');
        this.loading_error = false;
        this.loading = true;
        await model.deleteAll();
        await model.load();
        this.items = this.originalItems;
      } catch (e) {
        console.log(e, 'error');
        this.loading_error = true;
      } finally {
        this.loading = false;
      }
    },
    remove(item, index){
      if(item.$isNew){
        this.items.splice(index, 1);
        item.$delete();
      } else {
        this.items[index].$softDelete = true;
      }
    },
    async addItem(){
      await this.$store.$db().model('billingSeparatedItems').add();
      this.items = this.originalItems;
    },
    async updatePriority(){
      for(let i = 0; i< this.items.length; i+=1){
        this.items[i].priority = i;
      }
    }
  }
}
</script>

<style scoped>

</style>
